// extracted by mini-css-extract-plugin
export default {"TwoColsUl":"WhyWeSection_TwoColsUl__zY5cF"};